import gs1Instance from "../api-index";

const { post, get, put } = gs1Instance;

// Get all trading partners with pagination and filters
export const getAllTradingPartners = async (params = {}) => {
  const { page = 1, size = 10, clientId } = params;

  const queryParams = new URLSearchParams({
    page: page.toString(),
    size: size.toString(),
  });

  //   if (clientId) {
  //     queryParams.append("clientId", clientId.toString());
  //   }

  const response = await get(
    `/api/v1/trading-partners?${queryParams.toString()}`,
  );
  return response.data;
};

// Invite a trading partner
export const inviteTradingPartner = async (data) => {
  const response = await post("/api/v1/trading-partners/invite", data);
  return response.data;
};

// Switch context 
export const switchContextTradingPartner = async ({clientId}) => {
    const response = await post(`/api/v1/trading-partners/switch-context/${clientId}`)
    return response.data;
}

// Get all available permissions
export const getAllPermissions = async () => {
  const response = await get("/gs1/standard/roles/permissions/assignable");
  return response.data;
};


// Get all clients belonging to a trading partner
export const getAllClientsForTP = async () => {
    const response = await get(`/api/v1/clients/trading-partner`);
    return response.data;
}

// Update trading partner permissions
export const updateTradingPartnerPermissions = async ({
  userId,
  clientId,
  permissions,
}) => {
  const response = await put(`/api/v1/trading-partners/${userId}/permissions`, {
    clientId,
    permissions,
  });
  return response.data;
};
